import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { MatTableDataSource } from '@angular/material/table';
import { ConnectionService } from '../../services/connection.service';
import { MediaService } from '../../services/media.service';
import { HttpEventType } from '@angular/common/http';
import { Media } from '@contracts/interfaces/media.interfaces'
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { EbayService } from 'src/app/services/ebay.service';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss', './categories.scss', 'ap-table.scss', '../tabs.scss']
})
export class InventoryComponent implements OnInit {

  public loading = true;

  public searchQuery: string = null;

  public isSearching: boolean = false;

  public items: InventoryItem[] = [];

  public dataSource: MatTableDataSource<InventoryItem>;
  public dataSourceSearch: MatTableDataSource<InventoryItem>;

  public routesToCheck: string[] = []

  public activeTab: string = "";

  public notListedCount = 0;
  private unlistedOnly: boolean = false;

  columnsToDisplay = [
    'image',
    'code',
    'title',
    'salesChannels'
  ];

  constructor(
    private inventoryService: InventoryService,
    private inventoryCategoryService: InventoryCategoryService,
    private connectionService: ConnectionService,
    private mediaService: MediaService,
    private cdr: ChangeDetectorRef,
    private ebayService: EbayService
    ) {}

  ngOnInit(): void {
    this.activateTab("recent");
    this.loading = true;
    this.load();
  }

  load() {
    this.inventoryService.find({ status: { $ne: "checked-out" } }, "number", "asc").subscribe((items: InventoryItem[]) => {
      this.items = [];
      this.notListedCount = 0;

      for (let item of items) {
        if (!this.inventoryService.isListed(item)) {
          this.notListedCount++;
        }
      }

      if (this.unlistedOnly) {
        for (let item of items) {
          if (!this.inventoryService.isListed(item)) {
            this.items.push(item);
          }
        } 
      } else {
        this.items = items;
      }

      this.dataSource = new MatTableDataSource<InventoryItem>(this.items);

      this.loading = false;
    })
  }

  getTitle(title: string) {

    if (title == "") {
      return "Untitled";
    }
    
    return title;
  }

  openCategoriesDialog() {
    this.inventoryCategoryService.openInventoryCategoriesDialog();
  }

  viewItem(item: InventoryItem, currentIndex: number, onPageLoad: boolean = false) {
    let list: number[] = [];
    for (let i = 0; i < this.items.length; i++) {
      list.push(this.items[i].number);

      if (item.number == this.items[i].number) {
        currentIndex = i;
      }
    }

    this.inventoryService.openInventoryItemDialog(item, list, currentIndex, (r: any) => {
      this.load();
    });
  }


  getImage(item: InventoryItem, size = 130) {
    let x = '';
    if (item.media.length > 0) {
      let imagePath = this.connectionService.address + "/inventory/" + item.number + "/";
      if (item.media[0].filename != undefined) {      
        let y = item.media[0].filename.replace(/\(/g, '%28').replace(/\)/g, '%29');
        x = "background-image: url('" + imagePath + y + "?width="+size+"&height="+size+"&fit=cover');";
      }
    }
    return x;
  }

  getPlaceholder() {
    return `background-image: url('${this.connectionService.address}/inventory-category-pictures/placeholder.jpg');`;
  }

  activateTab(tab: string) {
    this.activeTab = tab;

    if (tab == "completed") {
      //this.loadCompleted();
    }

    if (tab == "snoozed") {
      //this.loadSnoozedTasks();
    }

    if (tab == "active") {
      //this.loadActiveTasks();
    }
  }

  filter (query: string) {
    this.dataSource.filter = query;
  }

  filterCancelled() {
    this.dataSource.filter = null;
  }

  showUnlistedOnly() {
    this.unlistedOnly = !this.unlistedOnly;
    this.load();
  }

  searchItem: InventoryItem = null;
  search (value: string) {
    this.inventoryService.get(+value).subscribe((inventoryItem: InventoryItem) => {
        if (inventoryItem == undefined) {
          this.searchItem = null;
        } else {
          this.searchItem = inventoryItem;
        }
    });
  }

  // getImage() {

  //   if (this.item.media.length > 0) {
  //       if (this.mediaService.getType(this.item.media[0]) == MediaType.IMAGE) {
  //         return this.connectionService.address + "/inventory/" + this.item.number + "/" + this.item.media[0].filename;
  //       }
  //   }
  // }

  tick(item: InventoryItem) {
    this.searchItem.stockTake = new Date();
    this.inventoryService.updateOne(item).subscribe(r => {});
  }

  checkout(item: InventoryItem) {
    item.status = "checked-out";
    item.checkOutReason = "";
    item.log.push({
      text: "",
      date: new Date()
    });

    this.ebayService.removeItem(item.ebay).subscribe(r => {
      item.ebay.ItemID = 0;
      this.inventoryService.updateOne(item).subscribe(r => {
        this.searchItem = null;
      });
    },
    error => {
      console.log(error)
      if (
        // "This item cannot be accessed because the listing has been deleted or you are not the seller."
        error.error.error.meta.Errors.ErrorCode == 17 ||
        // The auction has already been closed.
        error.error.error.meta.Errors.ErrorCode == 1047
      ) {
        item.ebay.ItemID = 0;
        this.inventoryService.updateOne(item).subscribe(r => {});
      }
    });

  }

} 
